/**
 * @generated SignedSource<<e0b84460a18977d0c2e8fca81778986d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UsersMapUserMarker_userMarker",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserMarkerTooltip_userMarker"
    }
  ],
  "type": "UserMarker",
  "abstractKey": null
};

node.hash = "a17abd7fb5f9282d006855f04257dfad";

module.exports = node;
